import extensionHooks from '../constants/extension-hooks';
import subscribe from './subscribe';

const subscribeToExtensionsHooks = (hookName, callback, options = {}) => {
  if (Object.values(extensionHooks).includes(hookName)) {
    subscribe(hookName, callback, options);
  }
};

export default subscribeToExtensionsHooks;
